// source: design/src/pages/ERPPage.tsx (export 2026-04-24)
/* eslint-disable max-len */
import SI from '../si/si_zh';

export default {
  // Reuse shared SI common copy to keep sub-pages aligned with SI root updates.
  common: SI.common,
  heroImage: 'si/images/hero-erp.jpg',
  heroTitle: '企业资源计划 (ERP)',
  heroTagline: '整合企业核心资源，驱动高效运营管理',
  intro: [
    'ERP（Enterprise Resource Planning，企业资源计划）是现代企业管理的核心信息系统，通过整合财务、采购、生产、销售、人力资源、供应链等关键业务流程，实现数据的统一管理与实时共享。',
    '作为企业数字化转型的基石，ERP系统帮助企业打破部门信息孤岛，建立标准化的业务流程，为管理层提供准确、及时的决策支持数据。',
    '飞狼拥有丰富的ERP实施经验，深度服务制造、零售、建筑、医疗等多个行业，为企业提供从需求分析、系统选型、定制开发到上线运维的全流程服务。',
  ],
  modules: [
    {
      icon: 'si/si-icons/dollar-sign.svg',
      title: '财务管理',
      desc: '涵盖总账、应收应付、固定资产、成本核算等核心财务功能，支持多币种、多会计准则，实现财务业务一体化。',
    },
    {
      icon: 'si/si-icons/shopping-bag.svg',
      title: '供应链管理',
      desc: '整合采购、库存、销售与分销全流程，从供应商管理、询价比价到订单跟踪、入库验收、出库发货的端到端管理，优化供应链协作与成本控制。',
    },
    {
      icon: 'si/si-icons/calendar.svg',
      title: '生产计划',
      desc: '基于MRP运算的生产计划排程，支持按订单生产(MTO)、按库存生产(MTS)等多种模式，提升产能利用率。',
    },
    {
      icon: 'si/si-icons/users.svg',
      title: '人力资源',
      desc: '覆盖组织架构、员工档案、考勤薪酬、绩效评估、招聘培训等HR全流程管理。',
    },
    {
      icon: 'si/si-icons/clipboard-list.svg',
      title: '项目管理',
      desc: '项目立项、任务分解、进度跟踪、成本控制、资源调配与项目结算的一体化管理。',
    },
    {
      icon: 'si/si-icons/bar-chart-3.svg',
      title: '报表与分析',
      desc: '内置多维度业务报表与BI分析工具，支持自定义报表与实时数据大屏展示。',
    },
  ],
  scenarios: [
    {
      icon: 'si/si-icons/factory.svg',
      title: '制造业',
      desc: 'ERP系统帮助制造企业实现从原材料采购、生产排程、质量检验到成品入库的全流程数字化管理，生产周期缩短15%-25%。',
    },
    {
      icon: 'si/si-icons/store.svg',
      title: '零售业',
      desc: '支持多渠道库存统一管理、会员数据分析、供应链协同，帮助零售企业提升库存周转率20%以上。',
    },
    {
      icon: 'si/si-icons/building-2.svg',
      title: '建筑工程',
      desc: '实现项目成本精细管控、材料采购优化、工程进度跟踪，有效控制项目超支风险。',
    },
    {
      icon: 'si/si-icons/heart-pulse.svg',
      title: '医疗健康',
      desc: '满足医疗器械追溯、药品批次管理、合规审计等严格要求，支持GMP/GSP规范。',
    },
  ],
  benefits: [
    {
      number: '10-20%',
      title: '降低运营成本',
      desc: '通过流程优化与资源整合，企业运营成本可降低10%-20%',
    },
    {
      number: '30%+',
      title: '实时数据驱动决策',
      desc: '管理层可基于实时业务数据做出准确决策，决策效率提升30%以上',
    },
    {
      number: '60-80%',
      title: '跨部门流程协同',
      desc: '打破信息孤岛，业务流程自动化率可达60%-80%',
    },
    {
      number: '100%',
      title: '合规与审计保障',
      desc: '内置审计追踪与权限管理，满足等保及行业合规要求',
    },
  ],
};
